// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import ACCOUNT_CONSTANTS from '@tcp/core/src/components/features/account/Account/Account.constants';
import Row from '../../../../../../common/atoms/Row';
import Col from '../../../../../../common/atoms/Col';
import BodyCopy from '../../../../../../common/atoms/BodyCopy';
import MyProfileTile from '../../../../../../common/molecules/MyProfileTile';
import { isSNJ } from '../../../../../../../utils';
import withStyles from '../../../../../../common/hoc/withStyles';
import styles from '../styles/MyFavoriteStore.style';
import MyProfileLabels, { ACCOUNT_COMMON } from '../../../views/MyProfile.labels';
import {
  getLabelFromCopyOrFromTranslation,
  renderLabel,
} from '../../../../../../../utils/labels/labelUtilty';
import {
  GLOBAL_ACTIONS_LABELS,
  GlobalActionsLabels,
  lblEdit,
} from '../../../../../../../utils/labels/globalActions.labels';

const ctaTitleDefaultStore = (favStoreName, isMyReferences, accountCommonLabels) => {
  if (favStoreName) {
    if (isMyReferences) {
      return renderLabel(
        getLabelFromCopyOrFromTranslation(
          `${GLOBAL_ACTIONS_LABELS}.${lblEdit}`,
          GlobalActionsLabels
        ),
        'lbl_edit'
      );
    }
    return renderLabel(
      accountCommonLabels?.lbl_common_updateFavoriteStore,
      'lbl_common_updateFavoriteStore'
    );
  }
  return renderLabel(accountCommonLabels?.lbl_common_addAStore, 'lbl_common_addAStore');
};

const MyFavoriteStore = ({
  favStoreName,
  favStoreAddress,
  favStoreState,
  favStoreCity,
  favStoreZipcode,
  favStorePhone,
  className,
  isMyPreferences,
  useRouterNavigation,
}) => {
  const accountCommonLabels = getLabelFromCopyOrFromTranslation(ACCOUNT_COMMON, MyProfileLabels);

  const ANALYTICS_CONST = ACCOUNT_CONSTANTS.ACCOUNT_ANALYTICS;
  const getStoreEventData = (favStore, isMyRef) => {
    if (favStore) {
      let eventData = {};
      if (isMyRef) {
        eventData = {
          eventName: ANALYTICS_CONST.navigationName.preferences_edit,
          pageNavigationText: ANALYTICS_CONST.navigationText.preferences_edit,
        };
      } else {
        eventData = {
          eventName: ANALYTICS_CONST.navigationName.profile_addFavStore,
          pageNavigationText: ANALYTICS_CONST.navigationText.profile_addFavStore,
        };
      }
      return eventData;
    }
    return {
      eventName: ANALYTICS_CONST.navigationName.profile_addFavStore,
      pageNavigationText: ANALYTICS_CONST.navigationText.profile_addFavStore,
    };
  };

  const clickEventdata = getStoreEventData(favStoreName, isMyPreferences);
  const isSNJBrand = isSNJ();
  return (
    <MyProfileTile
      className={className}
      title={renderLabel(
        accountCommonLabels?.lbl_common_myFavoriteStore,
        'lbl_common_myFavoriteStore'
      )}
      ctaTitle={ctaTitleDefaultStore(favStoreName, isMyPreferences, accountCommonLabels)}
      ctaPath="/store-locator"
      ctaLink="/store-locator"
      dataLocator="myFavStoreLbl"
      favStoreName={favStoreName}
      clickEventdata={clickEventdata}
      useRouterNavigation={useRouterNavigation}
    >
      {isMyPreferences && (
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy
              className="elem-pb-XL"
              fontSize="fs16"
              data-locator="accessBuyOnline"
              fontFamily="secondary"
              component="p"
            >
              {renderLabel(
                accountCommonLabels?.lbl_common_accessBuyOnline,
                'lbl_common_accessBuyOnline'
              )}
            </BodyCopy>
          </Col>
        </Row>
      )}
      {!favStoreName && (
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy
              fontSize="fs16"
              data-locator="favStoreNotAdded"
              fontFamily="secondary"
              component="p"
            >
              {isSNJBrand
                ? ''
                : renderLabel(
                    accountCommonLabels?.lbl_common_favStoreNotAdded,
                    'lbl_common_favStoreNotAdded'
                  )}
            </BodyCopy>
          </Col>
        </Row>
      )}
      {favStoreName ? (
        <Row fullBleed>
          <Col
            colSize={{
              small: 6,
              medium: 8,
              large: 12,
            }}
          >
            <BodyCopy
              className="elem-pb-SM favStoreData capFirstLetter"
              fontSize="fs16"
              data-locator="storeName"
              fontFamily="secondary"
              component="p"
              fontWeight={isMyPreferences ? 'extrabold' : 'regular'}
            >
              {favStoreName}
            </BodyCopy>
            <BodyCopy
              className="elem-pb-SM favStoreData capFirstLetter"
              fontSize="fs16"
              data-locator="storeAddress"
              fontFamily="secondary"
              component="p"
            >
              {favStoreAddress}
            </BodyCopy>
            <BodyCopy
              className="elem-pb-SM favStoreData capFirstLetter"
              fontSize="fs16"
              data-locator="storeCityDetails"
              fontFamily="secondary"
              component="p"
            >
              {`${favStoreCity}, ${favStoreState} ${favStoreZipcode}`}
            </BodyCopy>
            <BodyCopy
              className="elem-pb-SM favStoreData"
              fontSize="fs16"
              data-locator="storePhoneNumber"
              fontFamily="secondary"
              component="p"
            >
              {favStorePhone}
            </BodyCopy>
          </Col>
        </Row>
      ) : null}
    </MyProfileTile>
  );
};

MyFavoriteStore.propTypes = {
  favStoreName: PropTypes.string,
  favStoreAddress: PropTypes.string,
  favStoreState: PropTypes.string,
  favStoreCity: PropTypes.string,
  favStoreZipcode: PropTypes.string,
  favStorePhone: PropTypes.string,
  className: PropTypes.string,
  isMyPreferences: PropTypes.bool,
  useRouterNavigation: PropTypes.bool,
};

MyFavoriteStore.defaultProps = {
  favStoreName: '',
  favStoreState: '',
  favStoreCity: '',
  favStoreZipcode: '',
  favStorePhone: '',
  favStoreAddress: '',
  className: '',
  isMyPreferences: false,
  useRouterNavigation: false,
};

export default withStyles(MyFavoriteStore, styles);
export { MyFavoriteStore as MyFavoriteStoreVanilla };
